import i18next from 'i18next';

import { useEffect } from 'react';

export const useSetLanguage = () => {
  const lang = i18next.language;

  useEffect(() => {
    const root = document.getElementById('root');
    if (root) {
      switch (lang) {
        case 'ru':
          root.classList.remove('lang-en');
          root.classList.add('lang-ru');
          break;
        case 'en':
          root.classList.remove('lang-ru');
          root.classList.add('lang-en');
          break;
        default:
          root.classList.remove('lang-ru');
          root.classList.add('lang-en');
      }
    }
  }, [lang]);
};
